import { render, staticRenderFns } from "./SetDates.vue?vue&type=template&id=0676b612"
import script from "./SetDates.vue?vue&type=script&lang=js"
export * from "./SetDates.vue?vue&type=script&lang=js"
import style0 from "./SetDates.vue?vue&type=style&index=0&id=0676b612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports